module.exports = __webpack_public_path__ + "img/M803.ef16c443.jpg";